import Controller from './Controller';

export default class PageController extends Controller {
  static boot() {
    Controller.boot(...arguments);
    FW.store.loaded('page', () => {
      window.Page = FW.store.get('page');
      Page.groups = FW.store.get('groups');
      Page.sections = FW.store.get('sections');
      if (FW.inEditor()) {
        window.parent.$p = $;
        if (FW.inEditor()) window.parent.FW.editor.addType('page', Page);
      }
    });

    FW.store.loaded('jsonLoaded', function() {
      FW.store.loaded('groups', function() {
        FW.store.get('page').boot();
        global.prerenderReady = true;
      });
    });
  }
}
